// extracted by mini-css-extract-plugin
export default {"Page":"Style_Page__+fQ6Y","Form":"Style_Form__Fq01a"};